// extracted by mini-css-extract-plugin
export default {"shoppingBagContainer":"ShoppingBag_shoppingBagContainer__xhQfO","upperContainer":"ShoppingBag_upperContainer__OpxRi","lowerContainer":"ShoppingBag_lowerContainer__gAmOS"};